import React from 'react';
import { Icon } from '@iconify/react';
import HakkimizdaImage from '../assets/images/hakkimizda.jpg';
import KollmorgenLogo from '../assets/images/kollmorgen-logo.png';
import GefranLogo from '../assets/images/gefran-logo.png';
import SieiLogo from '../assets/images/siei-logo.png';
import ExorLogo from '../assets/images/exor-logo.png';

const AboutUs = () => {
  return (
    <div className="min-h-screen pt-20 relative z-10">
      {/* Hero Section */}
      <div className="relative w-full">
        <img 
          src={HakkimizdaImage} 
          alt="Hakkımızda" 
          className="w-full h-auto"
        />
      </div>

      {/* Main Content */}
      <div className="max-w-4xl mx-auto px-4 py-16 bg-white relative z-10">
        {/* Ana İçerik */}
        <div className="prose prose-lg max-w-none">

        <h1 className="text-2xl font-bold text-[#2E3192] mb-6 text-center">
          Tecrübe, Uzmanlık ve Çözüm Bir Arada.
        </h1>

          <p className="text-gray-700 leading-relaxed mb-6 text-lg">
            Siz değerli müşterilerimize, Endüstriyel Ürün Tamiri ve Otomasyon alanında 20 yılı aşkın deneyimimizle, bakım, onarım, yenileme, revizyon, yedek parça ve yeni ürünü temini gibi birçok hizmet sunuyoruz.
          </p>
          
          <p className="text-gray-700 leading-relaxed mb-6 text-lg">
            Amacımız, ürünlerinizi en kısa sürede yeniden çalışır hale getirmek ve iş süreçlerinize kesintisiz destek sağlamaktır.
          </p>

          <p className="text-gray-700 leading-relaxed mb-6 text-lg">
            Tüm marka ve modellere hizmet veriyoruz, ancak bazı markalarda özel uzmanlığa sahibiz. Bu da daha hızlı ve güvenilir çözümler sunmamızı sağlıyor.
          </p>

          <p className="text-gray-700 leading-relaxed mb-6 text-lg">
            Müşteri memnuniyetini ön planda tutuyor, her işe titizlikle yaklaşıyoruz. Ürünlerinizi sadece onarmakla kalmıyor, aynı zamanda daha verimli ve uzun ömürlü hale getirmek için gerekli tüm teknik desteği sağlıyoruz.
          </p>

          <p className="text-gray-700 leading-relaxed mb-8 text-lg">
            Teknolojiyi yakından takip ediyor, hizmet kalitemizi her geçen gün geliştiriyoruz. Geçmişten gelen bilgi birikimimizi, bugünün ihtiyaçlarıyla birleştiriyor; size en uygun çözümleri sunmak için çalışıyoruz.
          </p>

          {/* Uzmanlaştığımız Markalar */}
          <div className="bg-white rounded-lg p-8 mb-12">
            <h3 className="text-2xl font-bold text-[#2E3192] mb-6 text-center">
              Geçmişten Bu Güne Tecrübe Edinip Uzmanlaştığımız Başlıca Markalar
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              <div className="text-center">
                <div className="bg-white rounded-lg p-4 shadow-md flex items-center justify-center h-24">
                  <img 
                    src={KollmorgenLogo} 
                    alt="Kollmorgen" 
                    className="max-w-full max-h-16 object-contain"
                  />
                </div>
              </div>
              <div className="text-center">
                <div className="bg-white rounded-lg p-4 shadow-md flex items-center justify-center h-24">
                  <img 
                    src={GefranLogo} 
                    alt="Gefran" 
                    className="max-w-full max-h-16 object-contain"
                  />
                </div>
              </div>
              <div className="text-center">
                <div className="bg-white rounded-lg p-4 shadow-md flex items-center justify-center h-24">
                  <img 
                    src={SieiLogo} 
                    alt="SIEI" 
                    className="max-w-full max-h-24 object-contain"
                  />
                </div>
              </div>
              <div className="text-center">
                <div className="bg-white rounded-lg p-4 shadow-md flex items-center justify-center h-24">
                  <img 
                    src={ExorLogo} 
                    alt="EXOR" 
                    className="max-w-full max-h-16 object-contain"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Vizyon ve Misyon */}
          <div className="grid md:grid-cols-2 gap-8">
            {/* Vizyon */}
            <div className="bg-gradient-to-br from-blue-100 to-blue-200 rounded-lg p-8 text-[#2E3192] border border-blue-200">
              <div className="flex items-center mb-4">
                <Icon icon="mdi:star" className="w-6 h-6 mr-2 text-[#2E3192]" />
                <h3 className="text-2xl font-bold">Vizyonumuz</h3>
              </div>
              <p className="text-lg leading-relaxed">
                "Endüstriyel elektronik ve otomasyon çözümlerinde öncü, güvenilir ve yenilikçi bir iş ortağı olmak; müşterilerimizin üretim süreçlerini kesintisiz ve verimli hale getirerek sektörde fark yaratmak."
              </p>
            </div>

            {/* Misyon */}
            <div className="bg-gradient-to-br from-blue-100 to-blue-200 rounded-lg p-8 text-[#2E3192] border border-blue-200">
              <div className="flex items-center mb-4">
                <Icon icon="mdi:target" className="w-6 h-6 mr-2 text-[#2E3192]" />
                <h3 className="text-2xl font-bold">Misyonumuz</h3>
              </div>
              <p className="text-lg leading-relaxed">
                "20 yılı aşkın deneyimimizle, servo sürücü, servo motor, HMI ve endüstriyel PC sistemlerinde bakım, onarım, yenileme ve test hizmetleri sunmak; yüksek kalite, hızlı hizmet ve müşteri memnuniyeti odaklı çözümler geliştirerek iş ortaklarımızın yanında olmak."
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
